import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {LoggingService} from '@services/logging.service';
import {Router} from '@angular/router';
import {Observable, OperatorFunction, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(
    private readonly router: Router,
    private readonly logging: LoggingService,
  ) {}

  public handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      this.logging.logError(error.message);
    } else {
      this.handleUnknownError();
    }
  }

  /* Usage: add into the .pipe() of calls to http.get/post etc. to automatically handle errors */
  public withErrorHandler<T>(): OperatorFunction<T, T> {
    return (ob: Observable<T>) => {
      return ob.pipe(
        catchError((e) => {
          this.handleError(e);
          return throwError(e);
        }),
      );
    };
  }

  public assert(condition: boolean, msg: string): void {
    console.assert(condition, msg);
    if (!condition) {
      this.logging.logError(msg);
    }
  }

  private handleUnknownError() {
    this.logging.logError('Ein unbekannter Fehler ist aufgetreten.');
  }
}
